import React, { Component } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import { Modal, Tooltip } from "antd";
import momentTimezone from "moment-timezone";

const localizer = momentLocalizer(moment);

export default class EventCalender extends Component {
  constructor(props) {
    super(props);
    this.state = {
      events: [
        {
          title: "Consortia Roundable",
          start: new Date("2023-12-11T11:00:00.00"),
          end: new Date("2023-12-11T15:00:00.00"),
          type: "consortia",
          starttime: "11:00",
          endtime: "15:00",
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a  type specimen book. It has survived not only five centuries",
        },
        {
          title: "EverythingALS Expert Talk",
          start: new Date("2023-12-13T08:00:00.00"),
          end: new Date("2023-12-13T12:00:00.00"),
          type: "eals",
          starttime: "08:00",
          endtime: "12:00",
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a  type specimen book. It has survived not only five centuries",
        },
        {
          title: "EverythingALS Expert Talk",
          start: new Date("2024-01-03T14:20:00.00"),
          end: new Date("2024-01-03T18:00:00.00"),
          type: "eals",
          starttime: "14:20",
          endtime: "18:00",
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a  type specimen book. It has survived not only five centuries",
        },
        // Add more events as needed
      ],
      modalStatus: false,
      singleEvent: {},
      eventStartTime: "",
      eventEndTime: "",
    };
  }
  openModal = (item, startTime, endTime) => {
    this.setState({
      modalStatus: true,
      singleEvent: item,
      eventStartTime: startTime,
      eventEndTime: endTime,
    });
  };
  closeModal = () => {
    this.setState({
      modalStatus: false,
      singleEvent: {},
      eventStartTime: "",
      eventEndTime: "",
    });
  };
  render() {
    const Event = ({ event }) => {
      if (event.type == "eals") {
        // cst time converted
        let startDate =
          moment(event.start).format("YYYY-MM-DD") + "T" + event.starttime;
        let startTime = momentTimezone(startDate)
          .tz("America/Chicago")
          .format("HH:mm");
        console.log("startTime original", event.start);
        console.log("startTime", startTime);

        let endDate =
          moment(event.end).format("YYYY-MM-DD") + "T" + event.endtime;
        let endTime = momentTimezone(endDate)
          .tz("America/Chicago")
          .format("HH:mm");
        console.log("endTime original", event.end);
        console.log("endTime", endTime);
        return (
          <div
            className="eals-event-block"
            onClick={() => this.openModal(event, startTime, endTime)}
          >
            <div className="time">
              <span className="tag">{startTime}</span>
              <span className="tag">{endTime}</span>
              <span className="time-zone-name">(CST)</span>
            </div>
            <p>{event.title}</p>
            <div className="avtars">
              <Tooltip title="Suzan Jackson">
                <img src="./assets/img/avatars/1.png" />
              </Tooltip>
              <Tooltip title="Nick Rongton">
                <img src="./assets/img/avatars/2.png" />
              </Tooltip>
            </div>
          </div>
        );
      } else {
        let startDate =
          moment(event.start).format("YYYY-MM-DD") + "T" + event.starttime;
        let startTime = momentTimezone(startDate)
          .tz("America/Chicago")
          .format("HH:mm");
        console.log("startTime original", event.start);
        console.log("startTime", startTime);

        let endDate =
          moment(event.end).format("YYYY-MM-DD") + "T" + event.endtime;
        let endTime = momentTimezone(endDate)
          .tz("America/Chicago")
          .format("HH:mm");
        console.log("endTime original", event.end);
        console.log("endTime", endTime);
        return (
          <div
            className="consortia-event-block"
            onClick={() => this.openModal(event, startTime, endTime)}
          >
            <div className="time">
              <span className="tag">{startTime}</span>
              <span className="tag">{endTime}</span>
              <span className="time-zone-name">(CST)</span>
            </div>
            <p>{event.title}</p>
            <div className="avtars">
              <Tooltip title="Suzan Jackson">
                <img src="./assets/img/avatars/1.png" />
              </Tooltip>
              <Tooltip title="Nick Rongton">
                <img src="./assets/img/avatars/2.png" />
              </Tooltip>
              <Tooltip title="Lisa Roman">
                <img src="./assets/img/avatars/3.png" />
              </Tooltip>
            </div>
          </div>
        );
      }
    };
    return (
      <div className="event-calender-wrapper">
        <Calendar
          localizer={localizer}
          events={this.state.events}
          components={{
            event: Event,
          }}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 950 }}
        />
        <Modal
          title={"Event Details"}
          visible={this.state.modalStatus}
          onOk={() => this.closeModal()}
          onCancel={() => this.closeModal()}
          okText="ok"
          cancelText="Cancel"
          width={500}
        >
          <div className="event-calender-content-wrapper">
            <p>
              <strong>Event Name:</strong> {this.state.singleEvent.title}
            </p>
            <p>
              <strong>Description:</strong> {this.state.singleEvent.description}
            </p>
            <p>
              <strong>Start Time:</strong>: {this.state.eventStartTime}
            </p>
            <p>
              <strong>End Time:</strong>: {this.state.eventEndTime}
            </p>
            <p>
              <strong>Zoom Link:</strong>
              <a href="#" className="zoom-link" target="_blank">
                Join
              </a>
            </p>
            <div className="modal-avtars">
              <Tooltip title="Suzan Jackson">
                <img src="./assets/img/avatars/1.png" />
              </Tooltip>
              <Tooltip title="Nick Rongton">
                <img src="./assets/img/avatars/2.png" />
              </Tooltip>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
